module.exports = __webpack_public_path__ + "static/media/sunbeam.c1c0c2c5.png";